import React, { useState } from 'react'
import { Button, Form } from 'react-bootstrap';
import { useQuery } from 'react-query';
import { useDispatch, useSelector } from 'react-redux';
import { Modal, InputGroup, Input, ModalHeader, ModalBody, ModalFooter, InputGroupAddon, InputGroupText } from 'reactstrap'
import addProjectUser from '../../../api/addProjectUser';
import getAdminUsers from '../../../api/getAdminUsers';
import Loader from '../../../pages/utilities/loader';
import { showToastAction } from '../../../redux/toastSlice';

const initData = {
    first_name: "",
    last_name: "",
    email_adress: "",
    password: "",
    user_type: ""
}

const AddUserModal = ({ show, handleClose, refetch }) => {
    const selectedProject = useSelector(state => state.selectedProject);
    const { isLoading, data: users } = useQuery("getAdminUsers", getAdminUsers);
    const [user, setUser] = useState({ user_type: "MASTER" });
    const dispatch = useDispatch()
    const submitUser = async () => {
        try {
            await addProjectUser(selectedProject.name, user);
            handleClose();
            refetch();
            dispatch(showToastAction({ message: "User added", showToast: true, severity: "success" }))
        }
        catch (err) {
            dispatch(showToastAction({ message: err.response?.data?.errorMessage ?? "Error", showToast: true }))
        }
    }

    if (isLoading) return <><Loader /></>

    return (
        <Modal isOpen={show} toggle={handleClose}>
            <ModalHeader toggle={handleClose}>
                Select use to add
            </ModalHeader>
            <ModalBody>
                <div className="flex flex-col gap-4">
                    <label className="label">
                        User
                        <Form>
                            <Form.Control as="select" onChange={(e) => setUser(e.target.value)}>
                                {users.data.map(({ username }) => <option key={username} value={username}>{username}</option>)}
                            </Form.Control>
                        </Form>
                    </label>
                </div>
            </ModalBody>
            <ModalFooter>
                <Button variant="secondary" onClick={handleClose}>
                    Fermer
                </Button>
                <Button variant="primary" onClick={submitUser}>
                    Ajouter utilisateur
                </Button>
            </ModalFooter>
        </Modal>
    );
}

export default AddUserModal
